import { signal } from '../services/SignalsService'

export function subscribe([sig, value]) {
  signal.on(sig, value)
}
